import { initGlide } from 'tools/glide';

const testimonialSlider = document.querySelector('#testimonialSlider, #slider-testimonial');
if (testimonialSlider) {
    const GLIDE_CONFIG = {
        gap: 75,
        peek: {
            before: 30,
            after: 30,
        },
        animationDuration: 0,
    };

    const GLIDE_COMPONENTS = {
        TestimonialSlider(Glide, Components) {
            Components.Swipe.move = () => undefined;

            return {};
        },
    };

    initGlide(testimonialSlider, GLIDE_CONFIG, GLIDE_COMPONENTS);
}
